import React, { useContext, useEffect } from 'react'
import { Card, CardBody } from '@react/react-spectrum/Card'
import Avatar from '@react/react-spectrum/Avatar'

import { RootContext } from '../../root/RootContext'
import './Operator.scss'

export default function Operator() {
  const { project } = useContext(RootContext)
  const operator = project.userContext

  useEffect(() => {
    if (document.querySelector('.operator .spectrum-Card-title'))
      document.querySelectorAll('.operator .spectrum-Card-title, .operator .spectrum-Card-subtitle').forEach((el) => {
        el.style.color = project.branding.headerTextColor
        el.style.fontFamily = project.branding.headingFont
      })
  }, [project])

  return (
    <div className='operator'>
      <Card
        variant='standard'
        allowsSelection={false}
        style={{
          backgroundColor: project.branding.mainNavBackgroundColor,
          color: project.branding.headerTextColor,
          fontFamily: project.branding.headingFont,
        }}
      >
        <Avatar className='avatar' alt={operator.name} src={operator.image} />
        <CardBody
          style={{
            color: project.branding.headerTextColor,
            fontFamily: project.branding.headingFont,
            backgroundColor: project.branding.mainNavBackgroundColor,
          }}
          subtitle={operator.role}
          title={operator.name}
        />
      </Card>
    </div>
  )
}
